import { Component, OnInit, PLATFORM_ID, Inject, ChangeDetectorRef } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TransferState, makeStateKey } from '@angular/platform-browser';

import 'rxjs/add/operator/filter';

import { ParameterService } from '../../services/parameter.service';
import { Parameter } from '../../models/parameter';
import { InvoiceInfo } from '../../models/invoice-info';
import { InvoiceService } from '../../services/invoice.service';
import { TaxGroupService } from '../../services/tax-group.service';
import { TaxGroup } from '../../models/tax-group';
import { TranslateService } from '@ngx-translate/core';

const INVOICEINFO_KEY = makeStateKey('invoiceInfo');
const ERROR_KEY = makeStateKey('errorMessage');
const PARAMETER_KEY = makeStateKey('parameter');
const TAXGROUP_KEY = makeStateKey('taxGroup');

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  invoiceInfo: InvoiceInfo;
  taxGroup: TaxGroup;
  parameter: Parameter;
  paymentError: string;
  errorMessage: string;
  invoiceToken: string;
  chamberId: string;
  source: string;
  userId: string;
  url: string;
  isServer: boolean;

  constructor(
    private state: TransferState,
    private route: ActivatedRoute,
    private invoiceInfoService: InvoiceService,
    private parameterService: ParameterService,
    private taxGroupService: TaxGroupService,
    private translateService: TranslateService,
    private ref: ChangeDetectorRef,
    @Inject(PLATFORM_ID) platformId
  ) {
    this.isServer = isPlatformServer(platformId);
    this.route
      .params
      .subscribe(params => {
        this.invoiceToken = params['id'];
      });
    this.route
      .queryParams
      .subscribe(params => {
        this.chamberId = params['chamber'];
      });
    this.route
      .queryParams
      .subscribe(params => {
        this.source = params['paymentsource'];
      });
    this.route
      .queryParams
      .subscribe(params => {
        this.userId = params['userid'];
      });
    this.route
      .queryParams
      .subscribe(params => {
        this.errorMessage = params['errMess'];
      });
  }

  ngOnInit() {
    this.invoiceInfo = this.state.get<InvoiceInfo>(INVOICEINFO_KEY, null);
    this.taxGroup = this.state.get<TaxGroup>(TAXGROUP_KEY, null);
    this.paymentError = this.state.get<string>(ERROR_KEY, null);
    this.parameterService.setParameter(this.state.get<Parameter>(PARAMETER_KEY, null));
    this.parameter = this.state.get<Parameter>(PARAMETER_KEY, null);

    if (!this.isServer) {
      this.parameterService.getPing();
    }

    if (!this.invoiceInfo && this.isServer && !this.paymentError) {
        this.invoiceInfoService.getInvoiceInfo(this.invoiceToken, this.chamberId)
        .then(invoiceInfo => {
          this.invoiceInfo = invoiceInfo;
          console.log(this.invoiceInfo);
          this.state.set<InvoiceInfo>(INVOICEINFO_KEY, invoiceInfo as InvoiceInfo);

          this.taxGroupService.getTaxGroup(this.invoiceInfo.Invoice.InvoiceId, this.chamberId)
          .then((taxGroup: TaxGroup) => {
            this.taxGroup = taxGroup;
            this.state.set<TaxGroup>(TAXGROUP_KEY, taxGroup);
          })
          .catch(() => {
            this.paymentError = 'Tax group not found';
          });
        })
        .catch(() => {
          this.paymentError = 'Payment not found';
          this.state.set<string>(ERROR_KEY, this.paymentError);
        });

        this.parameterService.getParameterAPI(this.chamberId)
        .then((parameter) => {
          this.parameterService.setParameter(parameter);
          this.parameter = parameter;
          this.state.set<Parameter>(PARAMETER_KEY, parameter as Parameter);
        })
        .catch(() => {
          this.paymentError = 'Parameter not found';
          this.state.set<string>(ERROR_KEY, this.paymentError);
        });
    }
  }

  onPaymentSucces() {
    this.errorMessage = null;
    this.invoiceInfo.Invoice.IsPaid = true;
    this.ref.detectChanges();
  }

  onPaymentError(error) {
    if (error.Code) {
      switch (error.Code) {
        case 1:
          this.errorMessage = this.translateService.instant('APIErrors.Fail');
          break;
        case 2:
          this.errorMessage = this.translateService.instant('APIErrors.Refund');
          break;
        case 3:
        case 6:
          this.errorMessage = this.translateService.instant('APIErrors.RefundFail');
          break;
        case 4:
          this.errorMessage = this.translateService.instant('APIErrors.Error');
          break;
        case 5:
          this.errorMessage = this.translateService.instant('APIErrors.Expired');
          break;
        case 7:
          this.errorMessage = this.translateService.instant('APIErrors.NoFund');
          break;
        case 9:
          this.errorMessage = this.translateService.instant('APIErrors.Retry');
          break;
        default:
          this.errorMessage = this.translateService.instant('APIErrors.Error');
          break;
      }
    } else if (error.Message) {
      this.errorMessage = error.Message;
    } else {
      this.errorMessage = error;
    }
    this.ref.detectChanges();
  }

  onDiscountCodeSucces() {
    this.invoiceInfoService.getInvoiceInfo(this.invoiceToken, this.chamberId)
    .then(invoiceInfo => {
      this.invoiceInfo = invoiceInfo;
      console.log(this.invoiceInfo);
      this.state.set<InvoiceInfo>(INVOICEINFO_KEY, invoiceInfo as InvoiceInfo);
    })
    .catch(() => {
      this.paymentError = 'Payment not found';
      this.state.set<string>(ERROR_KEY, this.paymentError);
    });
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/payment.component.ts